import { render } from "./BarOverlineChart.vue?vue&type=template&id=1900da99&scoped=true"
import script from "./BarOverlineChart.vue?vue&type=script&lang=js"
export * from "./BarOverlineChart.vue?vue&type=script&lang=js"

import "./BarOverlineChart.vue?vue&type=style&index=0&id=1900da99&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1900da99"]])

export default __exports__